<div class="header">
  <div class="header__info">
    <a class="header__logo_wrapper" [routerLink]="['/', companyId, 'models']">
      <svg-icon [src]="skyfishLogo" svgClass="header__logo"></svg-icon>
      <span class="header__version">v.{{ version }}</span>
    </a>
  </div>

  <div class="header__settings">
    <button
      *ngIf="themePreference$ | async as preference"
      type="button"
      nbButton
      ghost
      size="small"
      class="header__theme_toggle"
      [nbPopover]="themeMenu"
      nbPopoverPlacement="bottom"
      nbPopoverTrigger="click"
      [attr.aria-haspopup]="true"
      [attr.aria-label]="'Theme: ' + themeOptionLabels[preference]"
    >
      <nb-icon
        class="header__theme_icon"
        [icon]="themeIcons[preference]"
        [nbTooltip]="'Theme: ' + themeOptionLabels[preference]"
        nbTooltipPlacement="bottom"
      ></nb-icon>
    </button>

    <ng-template #themeMenu>
      <div
        *ngIf="themePreference$ | async as active"
        class="theme-menu"
        role="menu"
        aria-label="Theme"
      >
        <button
          *ngFor="let option of themeOptions"
          type="button"
          role="menuitemradio"
          class="theme-menu__item"
          [class.theme-menu__item--active]="active === option"
          [attr.aria-checked]="active === option"
          (click)="selectTheme(option)"
        >
          <nb-icon class="theme-menu__icon" [icon]="themeIcons[option]"></nb-icon>
          <span class="theme-menu__label">{{ themeOptionLabels[option] }}</span>
          <nb-icon *ngIf="active === option" class="theme-menu__check" icon="checkmark"></nb-icon>
        </button>
      </div>
    </ng-template>

    <ng-container *ngIf="isAuth">
      <button
        type="button"
        [nbContextMenu]="items"
        nbContextMenuTag="profile-menu"
        type="button"
        class="header__user header__opacity_button"
      >
        <span class="header__name">{{ user.firstName }} {{ user.lastName }}</span>
        <span class="header__title">{{ roles }}</span>
      </button>

      <div class="header__divider"></div>

      <app-company
        [logo]="companyLogo"
        [isCompanyMenuAvailable]="isUserInOtherCompanies() || hasAccessToAdminPanel()"
        [credits]="credits"
        (companyMenuToggle)="toggleMenu()"
        (creditsRequestDropdownToggle)="toggleCreditsRequestDropdown()"
      ></app-company>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="showDropDownMenu">
  <app-company-selection-drop-down></app-company-selection-drop-down>
</ng-container>

<ng-container *ngIf="showCreditsRequestDropdown">
  <app-credits-request-dropdown [credits]="credits"></app-credits-request-dropdown>
</ng-container>
